import 'helpers/configHelper';
import Bookings from './components/BookingActivity/BookingActivity';
import OccupationPlanning from './components/OccupancyPlanning/OccupationPlanning';
import Stays from './components/Stays/Stays';
import './App.css';

function App() {
    return (
        <div className="u-container u-container-spacing">
            <Bookings />
            <OccupationPlanning />
            <Stays />
        </div>
    );
}

export default App;
